import { init } from '@titttut/boring-table';

Drupal.behaviors.boring_table = {
  attach(context) {
    context.querySelectorAll('.prose table').forEach((table) => {
      init(table);
    });
  },
};
